export const LOCAL_STORAGE_USER_KEY = 'USER';
export const UNAUTHORISED_STATE_CODES = [420, 401];
